module.exports = __webpack_public_path__ + "static/media/beep-01a.238acd50.mp3";